import { put, select, takeEvery } from "redux-saga/effects";

import {
  ID_PERIODO_NO_DIA_INDICADORES_MERCADO,
  MODOS_EXIBICAO_INDICADORES_MERCADO,
  MODO_APP_SERIES,
} from "../model";
import {
  getModoExibicaoMedidaSelecionada,
  selecionarPeriodo,
  getModoApp,
} from "../state";

function* periodosSaga() {
  yield takeEvery(["ADICIONAR_MEDIDA", "SELECIONAR_MEDIDA"], function*(action) {
    const modoExibicaoMedidaSelecionada = yield select(
      getModoExibicaoMedidaSelecionada
    );

    const modoApp = yield select(getModoApp);

    if (
      MODOS_EXIBICAO_INDICADORES_MERCADO.includes(
        modoExibicaoMedidaSelecionada
      ) &&
      modoApp !== MODO_APP_SERIES
    ) {
      yield put(selecionarPeriodo([ID_PERIODO_NO_DIA_INDICADORES_MERCADO]));
    }
  });
}

export default periodosSaga;
